import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Container, Typography, Stack, Dialog } from '@mui/material';
import { ContactSalesData, CustomizePlan } from '../sections/@dashboard/contactSale';
import { getPublicUrl, PUBLIC_SITE_URL } from '../config/site';

const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]         
      : theme.palette.background.paper, 

  padding: theme.spacing(2.5),
  borderRadius: 20,

  boxShadow:
    theme.palette.mode === 'light'
      ? '0px 0px 10px rgba(0, 0, 0, 0.15)'
      : '0px 0px 10px rgba(0, 0, 0, 0.6)',
}));

export default function ContactSales() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [reloadData, setReloadData] = useState(false);
  const navigate = useNavigate();

  const openForm = (id) => {
    setSelectedUser(id);
    setIsFormOpen(true);
  };
  const closeForm = () => {
    setIsFormOpen(false);
    navigate('/dashboard/contact-sales');
  };
  const pageUrl = getPublicUrl('/dashboard/contact-sales');
  const imageUrl = getPublicUrl('/static/images/contact-sales.png');

  return (
    <>
      <Helmet>
        <title>Contact Sale | WatchNod </title>
        <meta
          name="description"
          content="Contact our sales team to customize a plan that fits your needs. Optimize your WatchNod experience with tailored solutions."
        />
        <meta
          name="keywords"
          content="Contact Sales, WatchNod, Customize Plan, Sales Team, Tailored Solutions"
        />
        <meta name="robots" content="noindex, follow" />
      
       
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Contact Sales | WatchNod",
            "description": "Get in touch with the WatchNod sales team to customize a plan that fits your needs.",
            "url": pageUrl,
            "image": imageUrl,
            "publisher": {
              "@type": "Organization",
              "name": "WatchNod",
              "url": PUBLIC_SITE_URL,
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": pageUrl
            }
          })}
        </script>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3" component="h1" gutterBottom>
            User Customize Plan
          </Typography>
        </Stack>

        <ContactSalesData openForm={openForm} key={reloadData} />

        <Dialog open={isFormOpen} onClose={closeForm}>
          <StyledCard>
            <CustomizePlan
              closeForm={closeForm}
              selectedUser={selectedUser}
              reloadData={() => setReloadData(!reloadData)}
            />
          </StyledCard>
        </Dialog>
      </Container>
    </>
  );
}
